import { Component } from '@angular/core';

@Component({
    selector: 'cmps-report-run-runs',
    templateUrl: './runs.component.html',
})
export class RunsComponent {
    rows = [];
}
